<script>
import FooterMap from "@js/components/Footer/Components/FooterMap.vue";
import {useCallbackFormsStore} from "@js/store/CallbackFormsStore.js";
import IconPhone from "@js/components/Icons/IconPhone.vue";
import {Link} from "@inertiajs/vue3";
import IconLogo from "@js/components/Icons/IconLogo.vue";
import {useMenuStore} from "@js/store/MenuStore.js";
import {useThemeStore} from "@js/store/ThemeStore.js";
import {WhenVisible} from '@inertiajs/vue3'
import IconWhatsApp from "@js/components/Icons/IconWhatsApp.vue";
import IconTelegram from "@js/components/Icons/IconTelegram.vue";

export default {
    name: "Footer",
    components: {IconTelegram, IconWhatsApp, IconLogo, IconPhone, FooterMap, Link, WhenVisible},
    data() {
        return {
            currentYear: new Date().getFullYear(),
        }
    },
    setup() {
        const themeStore = useThemeStore()
        const callbackStore = useCallbackFormsStore()
        const menuStore = useMenuStore()

        const products = menuStore.menuItems.find((item) => item.type === 'products_menu')

        return {themeStore, callbackStore, menuStore, products}
    },
};
</script>

<template>
    <WhenVisible data="permissions" :buffer="500">
        <FooterMap v-if="themeStore.footer_with_map"/>
    </WhenVisible>

    <footer class="bg-white shadow pb-20 md:pb-0">
        <div class="w-full max-w-screen-xl mx-auto p-4 md:py-8">
            <div class="flex items-center justify-between">
                <Link :href="route('home')" class="flex items-center space-x-3">
                    <img src="@img/logo/logo_black.webp" class="h-[60px] w-[128px]" alt="Лого" title="Лого"/>
                </Link>
                <ul class="flex flex-row font-medium mt-0 space-x-4 text-sm">
                    <li class="w-10 h-10 bg-indigo-600 rounded-full">
                        <div @click.prevent="callbackStore.showCallbackPopup"
                             class="w-full h-full flex items-center justify-center cursor-pointer">
                            <IconPhone class="w-6 h-6 text-white"/>
                        </div>
                    </li>
                    <li class="w-10 h-10 bg-whatsapp rounded-full">
                        <a href="https://api.whatsapp.com/send/?phone=79256649222&text&type=phone_number&app_absent=0"
                           class="w-full h-full flex items-center justify-center"
                           aria-label="WhatsApp" title="WhatsApp">
                            <IconWhatsApp class="w-6 h-6 text-white"/>
                        </a>
                    </li>
                    <li class="w-10 h-10 bg-telegram rounded-full">
                        <a href="https://t.me/Dorozhnyeplity" target="_blank" aria-label="Telegram" title="Telegram"
                           class="w-full h-full flex items-center justify-center">
                            <IconTelegram class="w-5 h-5 text-white -ms-0.5"/>
                        </a>
                    </li>
                </ul>
            </div>
            <hr class="my-6 border-gray-200 sm:mx-auto lg:mb-6"/>
            <div class="grid grid-cols-2 md:grid-cols-5 max-md:gap-y-10 gap-x-5">
                <template v-if="products" v-for="product in products.submenu">
                    <template v-for="submenu in product.submenu">
                        <div class="flex flex-col gap-3">
                            <Link :href="route(submenu.route_name, submenu.route_params)"
                                  class="text-sm font-bold text-gray-900 hover:text-indigo-600 transition mb-2">
                                {{ submenu.title }}
                            </Link>
                            <template v-for="submenu in submenu.submenu">
                                <Link :href="route(submenu.route_name, submenu.route_params)"
                                      class="text-sm font-medium text-gray-900 hover:text-indigo-600 transition">
                                    {{ submenu.title }}
                                </Link>
                            </template>
                        </div>
                    </template>
                </template>
                <div class="flex flex-col gap-3">
                    <div class="text-sm font-bold text-gray-900 mb-2">
                        Интересное
                    </div>
                    <Link :href="route('catalog')"
                          class="text-sm font-medium text-gray-900 hover:text-indigo-600 transition">
                        Каталог ЖБИ
                    </Link>
                    <Link :href="route('services')"
                          class="text-sm font-medium text-gray-900 hover:text-indigo-600 transition">
                        Услуги
                    </Link>
                    <Link :href="route('otzyvy')"
                          class="text-sm font-medium text-gray-900 hover:text-indigo-600 transition">
                        Отзывы
                    </Link>
                    <Link :href="route('contacts')"
                          class="text-sm font-medium text-gray-900 hover:text-indigo-600 transition">
                        Контакты
                    </Link>
                </div>
            </div>
            <hr class="my-6 border-gray-200 sm:mx-auto lg:my-8"/>
            <div class="sm:flex sm:items-center sm:justify-between">
                <div class="block text-xs md:text-sm mb-2 md:mb-0 text-gray-500 sm:text-center font-normal">
                    Copyright © {{ currentYear }}. Все права защищены.
                </div>
                <div class="block text-xs md:text-sm text-gray-500 sm:text-center font-normal">
                    ИНН: 5003164750 | КПП: 500301001 | ОГРН: 1245000090752
                </div>
            </div>
        </div>
    </footer>
</template>

<style scoped lang="scss">
footer {
    border-top: 1px solid hsla(0, 0%, 100%, .3);
}
</style>
